import React from 'react';
import Events from '@/requests/hooks/events';
import { workspaceRequestSteps } from '../constants';
import WorkspaceRequestWizardContent from './WorkspaceRequestWizardContent';
import WorkspaceRequestActions from './WorkspaceRequestActions';
import WorkspaceRequestCompleteActions from './WorkspaceRequestCompleteActions';
import WorkspaceSteps from './WorkspaceSteps';
import Selectors from '../hooks/selectors';

const wizardActions = {
  [workspaceRequestSteps.WORKSPACE.name]: { component: WorkspaceRequestActions },
  [workspaceRequestSteps.COMPLETE.name]: { component: WorkspaceRequestCompleteActions },
};

const WorkspaceRequestWizard = ({ code, compact, hideSteps }) => {
  const { activeStepIndex } = Selectors.useWorkspaceRequestWizard({ code });
  const updateStep = Events.useUpdateActiveStep('workspaces', { code });

  const activeStep = Object.values(workspaceRequestSteps)[activeStepIndex].name;

  const goToStep = (step) => {
    if (step < Object.values(workspaceRequestSteps).length && step >= 0) { updateStep({ step }); }
  };

  const WorkspaceRequestWizardActions = wizardActions[activeStep]?.component;

  return (
    <div className={compact ? 'tab-wizard-compact' : 'tab-wizard'}>
      {!hideSteps && (<WorkspaceSteps code={code} compact={compact} goToStep={goToStep} />)}
      <WorkspaceRequestWizardContent activeStep={activeStep} code={code} compact={compact} hideSteps={hideSteps} />
      <WorkspaceRequestWizardActions code={code} compact={compact} goBack={() => goToStep(0)} />
    </div>
  );
};

export default WorkspaceRequestWizard;
